function getPersistentPageState() {
  return JSON.parse(localStorage.getItem(window.location.pathname))
}

export default getPersistentPageState
